module.exports = "data:image/gif;base64,R0lGODlhBwAHAIABAAAAAP///yH5BAEAAAEALAAAAAAHAAcAAAIMjGGJmMH9mHQ0AlYAADs="


//////////////////
// WEBPACK FOOTER
// ./public/tinymce/img/anchor.gif
// module id = 413
// module chunks = 0